import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //response results
  results: null,
  // Productivity Index
  productivityIndex: "",
  progressProductivityIndex: "",
  productivityLandCover: "",
  progressProductivityLandCover: "",
  productivityYears: {
    from: null,
    to: null,
  },
  productivityDecimals: 1,
  progressProductivityDecimals: 1,

  // Land Cover
  landCoverIndex: "",
  progressLandCoverIndex: "",
  landCoverYears: {
    from: null,
    to: null,
  },
  landCoverIndicatorMatrix: null,
  landCoverAdvanced: {
    enabled: false,
    firstLandCover: null,
    lastLandCover: null,
    transformationMatrix: {
      treeCovered: [],
      grassland: [],
      cropland: [],
      wetland: [],
      artificialArea: [],
      bareLand: [],
      water: [],
    },
  },

  // Soil Organic Carbon
  soilOrganicIndex: "",
  progressSoilOrganicIndex: "",
  progressSoilOrganicLandCoverIndex: "",
  soilOrganicLandCoverIndex: "",
  soilOrganicYears: {
    from: null,
    to: null,
  },
  soilOrganicAdvanced: {
    enabled: false,
    firstSoilOrganic: null,
    lastSoilOrganic: null,
  },
  soilOrganicLandCoverAdvanced: {
    enabled: false,
    firstSoilOrganicLandCover: null,
    lastSoilOrganicLandCover: null,
    transformationMatrix: {
      treeCovered: [],
      grassland: [],
      cropland: [],
      wetland: [],
      artificialArea: [],
      bareLand: [],
      water: [],
    },
  },

  // Progress Period
  progressYears: {
    productivity: {
      from: null,
      to: null,
    },
    landcover: {
      from: null,
      to: null,
    },
    soilorganic: {
      from: null,
      to: null,
    },
  },
  productivityAdvanced: {
    enabled: false,
    firstLandCover: null,
    lastLandCover: null,
    transformationMatrix: {
      treeCovered: [],
      grassland: [],
      cropland: [],
      wetland: [],
      artificialArea: [],
      bareLand: [],
      water: [],
    },
  },
  progressProductivityAdvanced: {
    enabled: false,
    firstLandCover: null,
    lastLandCover: null,
    transformationMatrix: {
      treeCovered: [],
      grassland: [],
      cropland: [],
      wetland: [],
      artificialArea: [],
      bareLand: [],
      water: [],
    },
  },
  progressLandCoverIndicatorMatrix: null,
  progressLandCoverAdvanced: {
    enabled: false,
    firstLandCover: null,
    lastLandCover: null,
    transformationMatrix: {
      treeCovered: [],
      grassland: [],
      cropland: [],
      wetland: [],
      artificialArea: [],
      bareLand: [],
      water: [],
    },
  },
  progressSoilOrganicAdvanced: {
    enabled: false,
    firstSoilOrganic: null,
    lastSoilOrganic: null,
  },
  progressSoilOrganicLandCoverAdvanced: {
    enabled: false,
    firstSoilOrganicLandCover: null,
    lastSoilOrganicLandCover: null,
    transformationMatrix: {
      treeCovered: [],
      grassland: [],
      cropland: [],
      wetland: [],
      artificialArea: [],
      bareLand: [],
      water: [],
    },
  },
};

const landDegradationSlice = createSlice({
  name: "landDegradation",
  initialState,
  reducers: {
    setResults: (state, action) => {
      console.log("action.payload:", action.payload);
      state.results = action.payload;
      console.log("results:", state.results);
    },

    setProductivityDecimals: (state, action) => {
      state.productivityDecimals = action.payload;
    },
    setProgressProductivityDecimals: (state, action) => {
      state.progressProductivityDecimals = action.payload;
    },

    setProductivityIndex: (state, action) => {
      state.productivityIndex = action.payload;
    },
    setProgressProductivityIndex: (state, action) => {
      state.progressProductivityIndex = action.payload;
    },
    setProductivityLandCover: (state, action) => {
      state.productivityLandCover = action.payload;
    },
    setProgressProductivityLandCover: (state, action) => {
      state.progressProductivityLandCover = action.payload;
    },
    setProductivityYears: (state, action) => {
      if (action.payload.from !== undefined) {
        state.productivityYears.from = action.payload.from;
      }
      if (action.payload.to !== undefined) {
        state.productivityYears.to = action.payload.to;
      }
    },
    setLandCoverIndex: (state, action) => {
      state.landCoverIndex = action.payload;
    },
    setLandCoverIndicatorMatrix: (state, action) => {
      state.landCoverIndicatorMatrix = action.payload;
    },
    setProgressLandCoverIndicatorMatrix: (state, action) => {
      state.progressLandCoverIndicatorMatrix = action.payload;
    },
    setProgressLandCoverIndex: (state, action) => {
      state.progressLandCoverIndex = action.payload;
    },
    setLandCoverYears: (state, action) => {
      if (action.payload.from !== undefined) {
        state.landCoverYears.from = action.payload.from;
      }
      if (action.payload.to !== undefined) {
        state.landCoverYears.to = action.payload.to;
      }
    },
    setSoilOrganicIndex: (state, action) => {
      state.soilOrganicIndex = action.payload;
    },
    setSoilOrganicLandCoverIndex: (state, action) => {
      state.soilOrganicLandCoverIndex = action.payload;
    },
    setProgressSoilOrganicIndex: (state, action) => {
      state.progressSoilOrganicIndex = action.payload;
    },
    setProgressSoilOrganicLandCoverIndex: (state, action) => {
      state.progressSoilOrganicLandCoverIndex = action.payload;
    },
    setSoilOrganicYears: (state, action) => {
      if (action.payload.from !== undefined) {
        state.soilOrganicYears.from = action.payload.from;
      }
      if (action.payload.to !== undefined) {
        state.soilOrganicYears.to = action.payload.to;
      }
    },
    setProgressYears: (state, action) => {
      const { type, from, to } = action.payload;
      if (from !== undefined) {
        state.progressYears[type].from = from;
      }
      if (to !== undefined) {
        state.progressYears[type].to = to;
      }
    },
    resetLandDegradation: () => initialState,
    setProductivityAdvanced: (state, action) => {
      state.productivityAdvanced = {
        ...state.productivityAdvanced,
        ...action.payload,
      };
    },
    setTransformationMatrix: (state, action) => {
      state.productivityAdvanced.transformationMatrix = action.payload;
    },
    setAdvancedEnabled: (state, action) => {
      state.productivityAdvanced.enabled = action.payload;
    },
    setProgressProductivityAdvanced: (state, action) => {
      state.progressProductivityAdvanced = {
        ...state.progressProductivityAdvanced,
        ...action.payload,
      };
    },
    setProgressTransformationMatrix: (state, action) => {
      state.progressProductivityAdvanced.transformationMatrix = action.payload;
    },
    setProgressAdvancedEnabled: (state, action) => {
      state.progressProductivityAdvanced.enabled = action.payload;
    },
    setLandCoverAdvanced: (state, action) => {
      state.landCoverAdvanced = {
        ...state.landCoverAdvanced,
        ...action.payload,
      };
    },
    setLandCoverTransformationMatrix: (state, action) => {
      state.landCoverAdvanced.transformationMatrix = action.payload;
    },
    setLandCoverAdvancedEnabled: (state, action) => {
      state.landCoverAdvanced.enabled = action.payload;
    },
    setSoilOrganicAdvanced: (state, action) => {
      state.soilOrganicAdvanced = {
        ...state.soilOrganicAdvanced,
        ...action.payload,
      };
    },
    setSoilOrganicLandCoverAdvanced: (state, action) => {
      state.soilOrganicLandCoverAdvanced = {
        ...state.soilOrganicLandCoverAdvanced,
        ...action.payload,
      };
    },
    setSoilOrganicTransformationMatrix: (state, action) => {
      state.soilOrganicAdvanced.transformationMatrix = action.payload;
    },
    setSoilOrganicLandCoverTransformationMatrix: (state, action) => {
      state.soilOrganicLandCoverAdvanced.transformationMatrix = action.payload;
    },
    setSoilOrganicAdvancedEnabled: (state, action) => {
      state.soilOrganicAdvanced.enabled = action.payload;
    },
    setSoilOrganicLandCoverAdvancedEnabled: (state, action) => {
      state.soilOrganicLandCoverAdvanced.enabled = action.payload;
    },
    setProgressLandCoverAdvanced: (state, action) => {
      state.progressLandCoverAdvanced = {
        ...state.progressLandCoverAdvanced,
        ...action.payload,
      };
    },
    setProgressLandCoverTransformationMatrix: (state, action) => {
      state.progressLandCoverAdvanced.transformationMatrix = action.payload;
    },
    setProgressLandCoverAdvancedEnabled: (state, action) => {
      state.progressLandCoverAdvanced.enabled = action.payload;
    },
    setProgressSoilOrganicAdvanced: (state, action) => {
      state.progressSoilOrganicAdvanced = {
        ...state.progressSoilOrganicAdvanced,
        ...action.payload,
      };
    },
    setProgressSoilOrganicLandCoverAdvanced: (state, action) => {
      state.progressSoilOrganicLandCoverAdvanced = {
        ...state.progressSoilOrganicLandCoverAdvanced,
        ...action.payload,
      };
    },
    setProgressSoilOrganicLandCoverTransformationMatrix: (state, action) => {
      state.progressSoilOrganicLandCoverAdvanced.transformationMatrix =
        action.payload;
    },
    setProgressSoilOrganicAdvancedEnabled: (state, action) => {
      state.progressSoilOrganicAdvanced.enabled = action.payload;
    },
    setProgressSoilOrganicLandCoverAdvancedEnabled: (state, action) => {
      state.progressSoilOrganicLandCoverAdvanced.enabled = action.payload;
    },
    syncLandCoverAdvanced: (state) => {
      state.progressLandCoverAdvanced = {
        ...state.progressLandCoverAdvanced,
        firstLandCover: state.landCoverAdvanced.firstLandCover,
        lastLandCover: state.landCoverAdvanced.lastLandCover,
        transformationMatrix: JSON.parse(
          JSON.stringify(state.landCoverAdvanced.transformationMatrix)
        ),
      };
    },
    syncSoilOrganicAdvanced: (state) => {
      state.progressSoilOrganicAdvanced = {
        ...state.progressSoilOrganicAdvanced,
        firstLandCover: state.soilOrganicAdvanced.firstLandCover,
        lastLandCover: state.soilOrganicAdvanced.lastLandCover,
        transformationMatrix: JSON.parse(
          JSON.stringify(state.soilOrganicAdvanced.transformationMatrix)
        ),
      };
    },
  },
});

export const {
  setResults,
  setProductivityIndex,
  setProgressProductivityIndex,
  setProductivityLandCover,
  setProgressProductivityLandCover,
  setProductivityYears,
  setProductivityDecimals,
  setProgressProductivityDecimals,
  setLandCoverIndex,
  setProgressLandCoverIndex,
  setLandCoverYears,
  setSoilOrganicIndex,
  setSoilOrganicLandCoverIndex,
  setProgressSoilOrganicIndex,
  setSoilOrganicYears,
  setProgressYears,
  resetLandDegradation,
  setProductivityAdvanced,
  setTransformationMatrix,
  setAdvancedEnabled,
  setProgressProductivityAdvanced,
  setProgressTransformationMatrix,
  setProgressAdvancedEnabled,
  setLandCoverAdvanced,
  setLandCoverIndicatorMatrix,
  setProgressLandCoverIndicatorMatrix,
  setLandCoverTransformationMatrix,
  setLandCoverAdvancedEnabled,
  setSoilOrganicAdvanced,
  setSoilOrganicTransformationMatrix,
  setSoilOrganicLandCoverTransformationMatrix,
  setSoilOrganicAdvancedEnabled,
  setSoilOrganicLandCoverAdvancedEnabled,
  setProgressLandCoverAdvanced,
  setProgressLandCoverTransformationMatrix,
  setProgressLandCoverAdvancedEnabled,
  setProgressSoilOrganicAdvanced,
  setProgressSoilOrganicTransformationMatrix,
  setProgressSoilOrganicAdvancedEnabled,
  syncLandCoverAdvanced,
  syncSoilOrganicAdvanced,
  setSoilOrganicLandCoverAdvanced,
  setProgressSoilOrganicLandCoverIndex,
  setProgressSoilOrganicLandCoverAdvancedEnabled,
  setProgressSoilOrganicLandCoverAdvanced,
  setProgressSoilOrganicLandCoverTransformationMatrix,
} = landDegradationSlice.actions;

export default landDegradationSlice.reducer;
